/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { MessageStrip, Title, Text } from '@ui5/webcomponents-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const ErrorPage = () => {
    const search = useLocation().search;
    const navigate = useNavigate();
    const [correlationId, setCorrelationId] = useState<string>('');
    useEffect(() => {
        const correlationId = new URLSearchParams(search).get('correlationId');
        if (!correlationId) navigate('/');
        else setCorrelationId(correlationId);
    }, []);
    return (
        <div
            style={{
                padding: '6rem',
                maxWidth: '1024px',
            }}
        >
            <div style={{ display: 'flex', margin: 12 }}>
                <Title level="H2" data-testid="error-header">
                    Something went wrong
                </Title>
            </div>
            <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'start', flexDirection: 'row', width: 'auto' }}>
                <MessageStrip design="Negative" hideCloseButton={true}>
                    SAP Provider could not process the request received. Delete your browser cache and stored cookies, and restart your browser. If
                    you still experience issues after doing this, please create a ticket with this component in SAP for Me: BNS-ARI-FRE.
                </MessageStrip>
            </div>
            <div data-testid="error-sub-header" style={{ display: 'flex', margin: 12, marginTop: '36px' }}>
                <Title level="H4">Troubleshooting</Title>
            </div>
            <div
                data-testid="error-sub-content"
                style={{ display: 'flex', justifyContent: 'start', alignItems: 'start', flexDirection: 'row', width: 'auto', margin: 12 }}
            >
                <Text>
                    You may provide the correlation id in the ticket : <b data-testid="correlationId-text">{correlationId}</b>
                    <br />
                </Text>
            </div>
        </div>
    );
};

export default ErrorPage;
